import { FaWarehouse, FaHome, FaWrench, FaGavel, FaEnvelope, FaPhone, FaMapMarkerAlt } from "react-icons/fa"

const PLACE_TYPE_ICONS = {
  'Dealer Lot': FaWarehouse,
  'Dealer Home': FaHome,
  'Repair Facility': FaWrench,
  'Auction': FaGavel,
  'Mailing': FaEnvelope,
  'Additional Phone': FaPhone,
  'Other': FaMapMarkerAlt,
}

export default function PlaceTypeIcon({ placeTypeName, className }) {
  const Icon = PLACE_TYPE_ICONS[placeTypeName] || FaMapMarkerAlt

  return <Icon className={className} />
}
